// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shield-error"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 4.65L3 12C3 19.35 12 22.5 12 22.5C12 22.5 21 19.35 21 12L21 4.65L12 1.5L3 4.65Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 4.65L3 12C3 19.35 12 22.5 12 22.5C12 22.5 21 19.35 21 12L21 4.65L12 1.5L3 4.65Z","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 15.5L12 11M12 7.5L11.9961 7.5L11.9961 7.49609L12 7.49609L12 7.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ShieldErrorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shield-error',
    ref,
    icon: element,
  },
));

ShieldErrorIcon.displayName = 'ShieldErrorIcon';

export default ShieldErrorIcon;
